interface TranslationTable {
    [errorCode: string]: string;
}

export class ErrorCodeTranslator {
    private static readonly defaultMessage = $localize`Something went wrong, please try again later`;

    private static readonly translationTable: TranslationTable = {
        invalid_account: $localize`Provided credentials do not match any account or the account is not properly initialized`,
        invalid_password: $localize`Provided credentials do not match any account`,
        invalid_validation: $localize`Failed to validate inputs`,
        inactive_account: $localize`Provided credentials do not match any active account`,
        invalid_key: $localize`Invalid invitation key`,
        not_found: $localize`Item not found`,
        not_allowed: $localize`Insufficient permissions`,
        'validation.required': $localize`Required field`,
        'validation.mimes': $localize`File type not supported`,

        // Company errors
        company_name_exists: $localize`Company name already exists`,
        company_invalid_sf_id: $localize`Invalid Salesforce ID`,
        company_invalid_format: $localize`Invalid Salesforce ID format`,
        company_invalid_sf_id_exists: $localize`Salesforce ID already exists`,

        // User errors
        user_not_specified: $localize`User not specified`,
        user_not_found: $localize`User not found`,
        user_invalid_parameters: $localize`An error occured`, // not sure about this
        user_exists: $localize`User already exists`,
        user_disable: $localize`Cannot disable current user`,

        // Generic errors
        no_permissions: $localize`Not enough permissions to perform this action`,
        no_access: $localize`No access to perform this action`,
        error_occurred: $localize`An error occurred`,

        // Contacts
        create_emergency_contact_limit: $localize`The company has reached the limit of 10 emergency contacts. Delete a contact before adding a new one.`,
    };

    public static translate(errorCode: string): string {
        if (!errorCode) {
            return this.defaultMessage;
        }

        return this.translationTable[errorCode] || this.defaultMessage;
    }
}
